/* Dust & Mile header: mobile menu + inline search toggles. */
if (!customElements.get('dm-header')) {
  class DmHeader extends HTMLElement {
    connectedCallback() {
      this.menuToggle = this.querySelector('[data-dm-menu-toggle]');
      this.menu = this.querySelector('[data-dm-mobile-menu]');
      this.searchToggle = this.querySelector('[data-dm-search-toggle]');
      this.search = this.querySelector('[data-dm-search]');

      this.onKeyUp = this.onKeyUp.bind(this);
      this.onResize = this.onResize.bind(this);

      this.menuToggle?.addEventListener('click', () => this.setMenu(this.menu.hidden));
      this.searchToggle?.addEventListener('click', () => this.setSearch(this.search.hidden));
      document.addEventListener('keyup', this.onKeyUp);
      window.addEventListener('resize', this.onResize, { passive: true });
    }

    disconnectedCallback() {
      document.removeEventListener('keyup', this.onKeyUp);
      window.removeEventListener('resize', this.onResize);
    }

    setMenu(open) {
      if (!this.menu || !this.menuToggle) return;
      if (open) this.setSearch(false, false);
      this.menu.hidden = !open;
      this.menuToggle.setAttribute('aria-expanded', String(open));
      this.menuToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      document.body.classList.toggle('dm-menu-open', open);
      if (open) {
        this.menu.querySelector('a')?.focus({ preventScroll: true });
      }
    }

    setSearch(open, focus = true) {
      if (!this.search || !this.searchToggle) return;
      if (open) this.setMenu(false);
      this.search.hidden = !open;
      this.searchToggle.setAttribute('aria-expanded', String(open));
      if (open && focus) {
        const input = this.search.querySelector('input[type="search"]');
        if (input) {
          input.focus();
          const len = input.value.length;
          input.setSelectionRange?.(len, len);
        }
      }
    }

    onKeyUp(event) {
      if (event.code !== 'Escape') return;
      if (this.menu && !this.menu.hidden) {
        this.setMenu(false);
        this.menuToggle.focus();
      } else if (this.search && !this.search.hidden && this.search.contains(document.activeElement)) {
        // Let predictive search close its own results first.
        const results = this.search.querySelector('predictive-search[open]');
        if (results) return;
        this.setSearch(false);
        this.searchToggle.focus();
      }
    }

    onResize() {
      if (this.menu && !this.menu.hidden && window.innerWidth > 1100) this.setMenu(false);
    }
  }

  customElements.define('dm-header', DmHeader);
}
